import { render } from "./vendor.vue?vue&type=template&id=0701c56a"
import script from "./vendor.vue?vue&type=script&lang=js"
export * from "./vendor.vue?vue&type=script&lang=js"

import "./vendor.vue?vue&type=style&index=0&id=0701c56a&lang=css"

import exportComponent from "/home/runner/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__